import { render, staticRenderFns } from "./ProductInventoryItems.vue?vue&type=template&id=2f7aece4&"
import script from "./ProductInventoryItems.vue?vue&type=script&lang=js&"
export * from "./ProductInventoryItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports